module.exports = __webpack_public_path__ + "static/img/word03.b599e9d0.png";